import React, {useId} from 'react';

const Logo = ({className = 'text-2xl', align = 'center', dark = false}) => {
  const gradientId = `logo-gradient-${useId().replace(/:/g, '')}`;
  const alignmentClass = align === 'left' ? 'items-start' : 'items-center';
  const brandColor = dark ? 'text-gray-100' : 'text-navy-blue';
  const subtitleColor = dark ? 'text-gray-300' : 'text-gray-700';
  const accentColor = dark ? 'text-emerald-400' : 'text-emerald-700';

  return (
    <div
      className={`flex flex-col ${alignmentClass} font-extrabold ${className}`}
      style={{fontFamily: 'system-ui,sans-serif'}}
    >
      <div className="flex items-center">
        <div className="relative -top-[0.55em] left-[-0.05em] w-[1.1em] h-[1.1em] z-10">
          <svg
            viewBox="0 0 24 24"
            fill={`url(#${gradientId})`}
            aria-hidden="true"
            focusable="false"
          >
            <defs>
              <linearGradient
                id={gradientId}
                x1="0%"
                y1="100%"
                x2="100%"
                y2="0%"
              >
                <stop offset="0%" stopColor="#047857" />
                <stop offset="100%" stopColor="#059669" />
              </linearGradient>
            </defs>
            <path d="M2.5 15 L12 3 L21.5 15 L17 15 L12 8.5 L7 15 Z" />
          </svg>
        </div>
        <span className={`z-0 ${brandColor}`}>W</span>
        <span className={`${brandColor} tracking-tight ml-[-0.1em]`}>
          EALTHGEN
        </span>
        <span className={`${accentColor} text-[1.5em] leading-[0.1] ml-[-0.05em]`}>
          .
        </span>
      </div>
      <span className={`text-xs ${subtitleColor} mt-1 font-semibold`}>
        by Makarand Godbole
      </span>
    </div>
  );
};

export default Logo;